import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ml-auto" }
const _hoisted_2 = ["textContent"]

import { computed, onMounted, Ref, ref, toRefs } from 'vue';
import Column from 'primevue/column';
import Chip from 'primevue/chip';
import DataTable from 'primevue/datatable';
import ArchiveSwitch from '@/components/ArchiveSwitch';
import AddPersonModal from '@/components/AddPersonModal/AddPersonModal.vue';
import { useArchiveStore, useOrganizationParentStore } from '@/store';
import { OrganizationParentsAssociatedInterface } from '@/types';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum/permissions';


export default /*@__PURE__*/_defineComponent({
  __name: 'ParentsTable',
  props: {
  organizationId: {
    type: Number,
    default: null,
  },
},
  setup(__props) {

const props = __props;

const { organizationId } = toRefs(props);

onMounted(() => {
  if (can([PERMISSIONS.ORGANIZATION_PARENTS_INDEX])) getParents(false);
});

const organizationParentStore = useOrganizationParentStore();
const archiveStore = useArchiveStore();
const parents: Ref<OrganizationParentsAssociatedInterface[]> = ref([]);
const parentsCount: Ref<number> = computed(() => (parents.value ? parents.value.length : 0));
const parentsModalOpen = ref(false);
const archivedVisible = ref(false);

const getParents = async (showArchived: boolean) => {
  const filterArchived = showArchived ? '?archived=1' : '';
  parents.value = await organizationParentStore.getParentsForTable(organizationId.value, filterArchived);
};

const createMenuModel = (item: OrganizationParentsAssociatedInterface) => {
  const menuItems = [
    {
      label: 'Remove Parents',
      visible: can([PERMISSIONS.ORGANIZATION_DETACH_PARENTS]),
      command: () => {
        detachParents([item.id], item.full_name);
      },
    },
  ];
  if (item.archived_at) {
    menuItems.push({
      label: 'Unarchive',
      visible: can([PERMISSIONS.PEOPLE_ARCHIVE]),
      command: async () => {
        await archiveStore.unarchive(item.id);
        archiveStore.doToast(`${item.full_name} has been restored`, 'Unarchived');
      },
    });
  }
  return menuItems;
};

const attachParents: (ids: number[]) => Promise<void> = async (ids) => {
  await organizationParentStore.attachParents({ parents: ids }, organizationId.value);
  await getParents(false);
  organizationParentStore.doToast(`Parent(s) has been added`, 'Added');
};

const detachParents: (ids: number[], parentName: string) => Promise<void> = async (ids, parentName) => {
  await organizationParentStore.dettachParents({ parents: ids }, organizationId.value);
  await getParents(false);
  organizationParentStore.doToast(`${parentName} has been removed from organization`, 'Removed');
};

const openAddParents = async () => {
  parentsModalOpen.value = true;
  organizationParentStore.page = 0;
  await organizationParentStore.getAddParentsModalData(organizationId.value);
};

const onLoadMoreParents = async () => await organizationParentStore.getAddParentsModalData(organizationId.value);

const onCancelAdd = () => (parentsModalOpen.value = false);

const onSaveAdd = (parents: { name: string; value: number }[]) => {
  let parentsIds = parents.map((parents) => {
    return parents.value;
  });
  attachParents(parentsIds);
  parentsModalOpen.value = false;
};

const showArchived = () => {
  archivedVisible.value = true;
  organizationParentStore.showArchived = true;
  getParents(true);
};

const hideArchived = () => {
  archivedVisible.value = false;
  organizationParentStore.showArchived = false;
  getParents(false);
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ActionMenu = _resolveComponent("ActionMenu")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Parents", -1)),
      _createVNode(_unref(Chip), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(parentsCount.value), 1)
        ]),
        _: 1
      }),
      (_unref(can)([_unref(PERMISSIONS).ORGANIZATIONS_PARENTS_SHOW_ARCHIVE]))
        ? (_openBlock(), _createBlock(_unref(ArchiveSwitch), {
            key: 0,
            onEnable: showArchived,
            onDisable: hideArchived
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_ATTACH_PARENTS]))
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              id: "add-button",
              type: "text",
              size: "small",
              text: "Add Parents",
              "icon-left": "add",
              onClick: openAddParents
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(DataTable), {
        value: parents.value,
        "global-filter-fields": ['full_name'],
        "row-class": ({ archived_at }) => (archived_at ? 'grey-row' : null),
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: _unref(organizationParentStore).loading,
        "data-key": "full_name",
        "responsive-layout": "scroll",
        "scroll-height": "440px",
        "state-key": "session-store-facilitators-table",
        "state-storage": "session",
        class: _normalizeClass({ 'table-loading': _unref(organizationParentStore).loading })
      }, {
        empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("Parents not assigned", -1)
        ]))]),
        default: _withCtx(() => [
          (parentsCount.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(Column), {
                  "body-style": "max-width: 20rem",
                  field: "full_name",
                  header: "Parent Name",
                  "header-style": "max-width: 20rem; color: #3B4242;",
                  sortable: ""
                }, {
                  body: _withCtx(({ data }) => [
                    (data.archived_at)
                      ? _withDirectives((_openBlock(), _createBlock(_component_Icon, {
                          key: 0,
                          name: "info",
                          class: "mr-1 text-color-gray-dark text-base cursor-pointer"
                        }, null, 512)), [
                          [
                            _directive_tooltip,
                            {
                  value: 'Archived',
                  escape: true,
                  fitContent: true,
                },
                            void 0,
                            { top: true }
                          ]
                        ])
                      : _createCommentVNode("", true),
                    (_unref(can)([_unref(PERMISSIONS).PEOPLE_SHOW]))
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 1,
                          to: `/user/${data.id}`,
                          class: "font-semibold",
                          textContent: _toDisplayString(data.full_name)
                        }, null, 8, ["to", "textContent"]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "font-semibold",
                          textContent: _toDisplayString(data.full_name)
                        }, null, 8, _hoisted_2))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column)),
                _createVNode(_unref(Column), {
                  "body-style": "justify-content: center; font-size: .8725rem; max-width: 10rem;",
                  "header-style": "justify-content: center; max-width: 10rem",
                  field: "id",
                  header: "Actions"
                }, {
                  body: _withCtx(({ data }) => [
                    _createVNode(_component_ActionMenu, {
                      "menu-items": createMenuModel(data),
                      icon: "more_horiz"
                    }, null, 8, ["menu-items"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "row-class", "loading", "class"]),
      (parentsModalOpen.value && _unref(can)([_unref(PERMISSIONS).ORGANIZATION_ATTACH_PARENTS]))
        ? (_openBlock(), _createBlock(AddPersonModal, {
            key: 0,
            title: "Add parents",
            items: _unref(organizationParentStore).parentModalData,
            loading: _unref(organizationParentStore).modalDataLoading,
            searchable: true,
            "list-header-text": "Parent name",
            "button-text": "Add Parents",
            placeholder: "Search Parents",
            "person-type": "parents",
            onAddItems: onSaveAdd,
            onCancel: onCancelAdd,
            onLoadMoreItems: onLoadMoreParents
          }, null, 8, ["items", "loading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})